import PropTypes from 'prop-types'
import React from 'react'
import Modal from '@/checkout-instore-legacy/components/Commons/Elements/Modal'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import { CSSTransitionGroup } from '../CSSTransitionGroup'

function SlideUpModal({ isOpen, children, mediaQuery, ...rest }) {
  const transition = mediaQuery({
    desktop: {
      transitionName: 'fade',
      transitionEnterTimeout: 100,
      transitionLeaveTimeout: 100,
    },
    phone: {
      transitionName: 'slideUp',
      transitionEnterTimeout: 800,
      transitionLeaveTimeout: 300,
    },
  })

  return (
    <CSSTransitionGroup
      transitionName={transition.transitionName}
      transitionEnterTimeout={transition.transitionEnterTimeout}
      transitionLeaveTimeout={transition.transitionLeaveTimeout}
    >
      {isOpen ? <Modal {...rest}>{children}</Modal> : null}
    </CSSTransitionGroup>
  )
}

SlideUpModal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  mediaQuery: PropTypes.func,
}

export default withMediaQuery(SlideUpModal)
